// Récupération des données villes
const donneesVillesElement = document.querySelector('.js-donnes-villes');
const branchListing = document.querySelector('.branch-listing');


if (donneesVillesElement && branchListing) {
    const rawVilles = donneesVillesElement.getAttribute('data-villes');
    const department = donneesVillesElement.getAttribute('data-department');

    let villes = JSON.parse(rawVilles);

    // Filtrage par département
    const villesParDepartement = villes.filter(ville =>
        typeof ville.postcode === 'string' &&
        ville.postcode.startsWith(department)
    );

    // Nettoyage des branchName en double
    const branchMap = new Map();

    villesParDepartement.forEach(ville => {
        const key = ville.branchName?.trim() || `branch-${ville.id}`;

        if (!branchMap.has(key)) {
            branchMap.set(key, ville);
        }
    });

    const villesUniques = Array.from(branchMap.values());

    //Séparation sièges / antennes
    const sieges = villesUniques.filter(
        ville => ville.isHeadingOffice === 'oui'
    );

    const antennes = villesUniques;

    // Index des sièges par name
    const siegesParNom = new Map();

    sieges.forEach(siege => {
        if (siege.name) {
            siegesParNom.set(siege.name, siege);
        }
    });

    // Rendu des antennes
    antennes.forEach(ville => {
        const item = document.createElement('div');
        item.classList.add('branch-item');

        // Recherche du siège correspondant
        const siegeAssocie = siegesParNom.get(ville.name);

        if(siegeAssocie) {
            item.setAttribute('data-siege', siegeAssocie.name);
        }

        let html = `
            <h3 class="branch-name">${ville.branchName ?? ''}</h3>
        `;

        html += `
            <div class="item-siege">
                <p class="bold">Siège :</p>
                <p class="branch-office-name">${ville.name}</p>
        `

        // Adresse du siège
        if (siegeAssocie) {
            html += `
                <p class="branch-siege-address">
                    ${siegeAssocie.address} ${siegeAssocie.city} (${siegeAssocie.postcode})
                </p>
            `;
        }

        html += `</div>`;

        if (ville.email || ville.phone) {
            html += `
                <div class="item-contact">
                    <p class="bold">Contact :</p>
            `;
            if (ville.email) {
                html += `
                    <p class="branch-email">
                        <a href="mailto:${ville.email}">${ville.email}</a>
                        <img src="/content/uploads/2026/01/lien.png" alt="Icône lien" />
                    </p>
                `;
            }

            if (ville.phone) {
                html += `
                    <p class="branch-phone">
                        <a href="tel:${ville.phone.replace(/\s+/g, '')}">
                            ${ville.phone}
                        </a>
                        <img src="/content/uploads/2026/01/lien.png" alt="Icône lien" />
                    </p>
                `;
            }

            if (ville.url) {
                html += `
                    <p class="branch-url">
                        <a href="${ville.url}" target="_blank" rel="noopener noreferrer">
                            ${ville.url}
                        </a>
                        <img src="/content/uploads/2026/01/lien.png" alt="Icône lien" />
                    </p>
                `;
            }

            html += `<p class="bold">Appelez pour trouver la permanence la plus proche de chez vous.</p>`;

            html += `</div>`;
        }

        item.innerHTML = html;
        branchListing.appendChild(item);
    });
}

// Toutes les zones interactives de la carte
const mapZones = document.querySelectorAll('.zone');
const branchItems = Array.from(document.querySelectorAll('.branch-item'));

// Conteneur de la liste
const branchList = branchItems[0]?.parentElement;

// Sauvegarde de l’ordre initial
const initialOrder = [...branchItems];

let activeZone = null;

mapZones.forEach(zone => {
    const siegeName = zone.getAttribute('data-name');

    zone.addEventListener('click', () => {

        // Si on clique sur la zone déjà active → reset
        // if (activeZone === zone) {
        //     resetBranches();
        //     activeZone = null;
        //     return;
        // }

        // Sinon, on change de zone
        resetBranches();
        activeZone = zone;

        branchItems.forEach(item => {
            if (item.getAttribute('data-siege') === siegeName) {
                item.classList.add('is-highlighted');

                // Remonter l’élément en haut de la liste
                branchList.prepend(item);
            } else {
                item.classList.add('is-not-highlighted');
            }
        });
    });
});

// Fonction de reset
function resetBranches() {
    branchItems.forEach(item => {
        item.classList.remove('is-highlighted');
        item.classList.remove('is-not-highlighted');
    });

    initialOrder.forEach(item => {
        branchList.appendChild(item);
    });
}